(function () {
  var TRACKER_URL = 'https://tracker.megamarketbr.com/wa';
  var ALLOWED_PHONE = '5548991469477';
  var CLICK_ID_ATTR = 'data-mm-wa-click-id';
  var ORIGINAL_HREF_ATTR = 'data-mm-wa-original-href';
  var DECORATED_ATTR = 'data-mm-wa-tracked';

  function digits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function cookieValue(name) {
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    if (parts.length < 2) return '';
    return parts.pop().split(';').shift() || '';
  }

  function currentParams() {
    try {
      return new URLSearchParams(window.location.search || '');
    } catch (error) {
      return new URLSearchParams('');
    }
  }

  function randomId() {
    if (window.crypto && window.crypto.getRandomValues) {
      var bytes = new Uint8Array(12);
      window.crypto.getRandomValues(bytes);
      return Array.prototype.map.call(bytes, function (byte) {
        return byte.toString(16).padStart(2, '0');
      }).join('');
    }
    return String(Date.now()) + String(Math.random()).slice(2);
  }

  function parseUrl(value) {
    try {
      return new URL(value, window.location.href);
    } catch (error) {
      return null;
    }
  }

  function whatsappPhone(url) {
    var host = url.hostname.toLowerCase();
    if (host === 'api.whatsapp.com' || host === 'web.whatsapp.com' || host === 'www.api.whatsapp.com') {
      return digits(url.searchParams.get('phone'));
    }
    if (host === 'wa.me' || host === 'www.wa.me') {
      return digits(url.pathname.split('/').filter(Boolean)[0]);
    }
    return '';
  }

  function isTrackableWhatsAppHref(href) {
    var url = parseUrl(href);
    if (!url) return false;
    if (url.hostname.toLowerCase() === 'tracker.megamarketbr.com') return false;
    return whatsappPhone(url) === ALLOWED_PHONE;
  }

  function extractProductUrl(originalHref) {
    var url = parseUrl(originalHref);
    var decodedTarget = originalHref;

    if (url) {
      decodedTarget += '\n' + decodeURIComponent(url.searchParams.get('text') || '');
    }

    var match = decodedTarget.match(/https?:\/\/(?:www\.)?megamarketbr\.com\/products\/[^\s]+/i);
    if (match) return match[0];

    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical && /\/products\//.test(canonical.href)) return canonical.href;

    if (/\/products\//.test(window.location.pathname)) return window.location.href;
    return '';
  }

  function addIfPresent(url, key, value) {
    if (value) url.searchParams.set(key, value);
  }

  function buildTrackedHref(anchor, originalHref) {
    var params = currentParams();
    var tracker = new URL(TRACKER_URL);
    var clickId = anchor.getAttribute(CLICK_ID_ATTR) || randomId();
    var fbp = cookieValue('_fbp');
    var fbc = cookieValue('_fbc');
    var fbclid = params.get('fbclid') || '';

    if (!fbc && fbclid) {
      fbc = 'fb.1.' + Math.floor(Date.now() / 1000) + '.' + fbclid;
    }

    anchor.setAttribute(CLICK_ID_ATTR, clickId);
    tracker.searchParams.set('target', originalHref);
    tracker.searchParams.set('click_id', clickId);
    tracker.searchParams.set('page_url', window.location.href);
    tracker.searchParams.set('referrer', document.referrer || '');

    addIfPresent(tracker, 'product_url', extractProductUrl(originalHref));
    addIfPresent(tracker, 'utm_source', params.get('utm_source'));
    addIfPresent(tracker, 'utm_medium', params.get('utm_medium'));
    addIfPresent(tracker, 'utm_campaign', params.get('utm_campaign'));
    addIfPresent(tracker, 'utm_content', params.get('utm_content'));
    addIfPresent(tracker, 'utm_term', params.get('utm_term'));
    addIfPresent(tracker, 'gclid', params.get('gclid'));
    addIfPresent(tracker, 'gbraid', params.get('gbraid'));
    addIfPresent(tracker, 'wbraid', params.get('wbraid'));
    addIfPresent(tracker, 'fbclid', fbclid);
    addIfPresent(tracker, 'msclkid', params.get('msclkid'));
    addIfPresent(tracker, 'fbp', fbp);
    addIfPresent(tracker, 'fbc', fbc);

    return tracker.toString();
  }

  function decorateAnchor(anchor) {
    if (!anchor || !anchor.getAttribute) return;

    var originalHref = anchor.getAttribute(ORIGINAL_HREF_ATTR) || anchor.getAttribute('href') || '';
    if (!isTrackableWhatsAppHref(originalHref)) return;

    anchor.setAttribute(ORIGINAL_HREF_ATTR, originalHref);
    anchor.setAttribute(DECORATED_ATTR, 'true');
    anchor.setAttribute('href', buildTrackedHref(anchor, originalHref));

    if ((anchor.getAttribute('target') || '').toLowerCase() === '_blank') {
      var rel = (anchor.getAttribute('rel') || '').split(/\s+/);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      anchor.setAttribute('rel', rel.filter(Boolean).join(' '));
    }
  }

  function decorateAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var anchors = scope.querySelectorAll('a[href*="api.whatsapp.com"], a[href*="web.whatsapp.com"], a[href*="wa.me"]');
    Array.prototype.forEach.call(anchors, decorateAnchor);
  }

  document.addEventListener('pointerdown', function (event) {
    var anchor = event.target && event.target.closest ? event.target.closest('a') : null;
    decorateAnchor(anchor);
  }, true);

  document.addEventListener('click', function (event) {
    var anchor = event.target && event.target.closest ? event.target.closest('a') : null;
    decorateAnchor(anchor);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { decorateAll(document); });
  } else {
    decorateAll(document);
  }

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node && node.nodeType === 1) decorateAll(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
